<template>
  <div>
    <div class="form-row">
      <div
        class="
          col-12
          d-flex
          align-items-center
          flex-wrap
          mb-3
          flex-column flex-sm-row
          text-center
        "
      >
        <h5 class="text-blue-ml">Mis inscripciones</h5>
      </div>

      <div class="col-12 d-flex align-items-start pb-3" style="overflow: auto">
        <LoaderContent
          v-if="isLoading"
          :welcomeMessage="false"
          :alignSpinnerTop="true"
        />

        <div
          class="rounded-xl shadow-md flex-shrink-0 my-2 mr-5 p-4"
          style="max-width: 320px"
          v-for="(subscription, index) in subscriptions"
          :key="index"
          v-if="subscription.company && (subscription.company.id == $store.state.companyId || ($store.state.companyId2 && subscription.company.id == $store.state.companyId2) || ($store.state.companyId3 && subscription.company.id == $store.state.companyId3))"
        >
          <router-link
            :to="'/vagas/' + subscription.slug"
            class="d-flex flex-column"
            style="min-height: 115px"
          >
            <span
              class="h5 font-weight-normal text-dark"
              v-if="subscription.opportunity"
            >
              {{ $helpers.toTitle(subscription.opportunity.title) }}
            </span>

            <div class="d-flex mt-3 mb-2 text-secondary">
              <calendar-icon class="h4 mb-0 mr-2" />
              <span>{{
                $moment(subscription.createdAt).format("DD/MM/YYYY")
              }}</span>
            </div>

            <div class="d-flex text-secondary">
              <map-marker-icon class="h4 mb-0 mr-2" />

              <div
                v-if="
                  subscription.opportunity && subscription.opportunity.address
                "
              >
                <span
                  v-if="
                    subscription.opportunity.address.city &&
                    subscription.opportunity.address.stateAbbr
                  "
                  >{{ subscription.opportunity.address.city }} -
                  {{ subscription.opportunity.address.stateAbbr }}</span
                ><br />
                <span v-if="subscription.opportunity.address.street">{{
                  subscription.opportunity.address.street
                }}</span>
                <span v-if="subscription.opportunity.address.number"
                  >, {{ subscription.opportunity.address.number }}</span
                >
                <span v-if="subscription.opportunity.address.neighborhood">
                  - {{ subscription.opportunity.address.neighborhood }}</span
                >
              </div>
              <span v-else>Endereço não foi cadastrado</span>
            </div>
          </router-link>

          <SubscriptionTests :subscription="subscription" />

          <div v-if="subscription.step == 'lead'" >
            <hr />
            <router-link
              :to="`/vagas/${subscription.opportunityId}/inscricao`"
              class="btn btn-blue-ml flex-shrink-0"
              v-if="subscription.opportunity.status == '1'">
              Continuar Inscrição
            </router-link>

            <h6 v-else class="mb-0 font-weight-normal text-secondary">No ha completado su registro antes de la fecha de vencimiento, pero la empresa puede comunicarse con usted.</h6>
          </div>
        </div>

        <button
          class="btn btn-blue-ml align-self-center flex-shrink-0"
          @click="loadSubscriptions"
          v-if="hasNext && !isLoading"
        >
        Cargar más ...
        </button>
        <SpinnerLoader
          v-if="isLoading"
          class="align-self-center flex-shrink-0"
        />
      </div>
    </div>

    <p v-if="subscriptions.length == 0">No hay registro</p>
  </div>
</template>

<script>
import MapMarkerIcon from 'vue-material-design-icons/MapMarker.vue';
import CalendarIcon from 'vue-material-design-icons/Calendar.vue';
import LoaderContent from '../Loader/LoaderContent.vue';
import SpinnerLoader from '../Loader/SpinnerLoader';
import SubscriptionTests from './SubscriptionTests.vue';

export default {
  name: 'BoxSubscriptions',

  data() {
    return {
      isLoading: false,
      page: 0,
      hasNext: true,
    };
  },

  computed: {
    subscriptions() {
      return this.$store.state.opportunities.subscriptions || [];
    },
  },

  components: {
    LoaderContent,
    SpinnerLoader,
    SubscriptionTests,
    MapMarkerIcon,
    CalendarIcon,
  },

  mounted() {
    this.loadSubscriptions();
  },

  methods: {
    loadSubscriptions() {
      this.isLoading = true;
      this.page++;

      this.$store
        .dispatch('opportunities/subscriptionsWithPagination', {
          page: this.page,
          getOnlineTests: true,
        })
        .then((subscriptions) => {
          if (this.$store.state.companyId2) {
            this.$store
              .dispatch('opportunities/subscriptionsWithPagination', {
                page: this.page,
                getOnlineTests: true,
                companyId: this.$store.state.companyId2,
              })
              .then((subscriptions2) => {
                if (this.$store.state.companyId3) {
                  this.$store
                    .dispatch('opportunities/subscriptionsWithPagination', {
                      page: this.page,
                      getOnlineTests: true,
                      companyId: this.$store.state.companyId3,
                    })
                    .then((subscriptions3) => {
                      // eslint-disable-next-line max-len
                      this.hasNext = subscriptions.meta.next_page != null || subscriptions2.meta.next_page != null || subscriptions3.meta.next_page != null;
                      this.isLoading = false;
                    });
                } else {
                  this.hasNext = subscriptions2.meta.next_page != null;
                  this.isLoading = false;
                }
              });
          } else {
            this.hasNext = subscriptions.meta.next_page != null;
            this.isLoading = false;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
